import Notification from './NotificationContainer';

export { Notification };


// WEBPACK FOOTER //
// ./src/modules/notification/Notification/index.js